import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const d=t("antigua_and_barbuda",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5V20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L24 4.5L22.4348 12.5L1.56522 12.5L0 4.5Z"
                fill="black" />
            <path
                d="M12.0011 12.1539L5.79687 10.7752L8.95894 10.3712L6.27046 9.19106L9.42218 9.62535L7.6147 7.84958L10.2784 9.05457L9.62692 6.95342L11.3972 8.74574L12.0031 6.6377L12.6091 8.74574L14.3793 6.95342L13.7279 9.05457L16.3915 7.84958L14.5841 9.62535L17.7358 9.19106L15.0473 10.3712L18.2094 10.7752L12.0052 12.1539H12.0011Z"
                fill="#FCD116" />
            <path
                d="M1.56641 10.7607L22.436 10.7607V14.239L1.56641 14.239L1.56641 10.7607Z"
                fill="#0072C6" />
            <path
                d="M0 4.5L12 20.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#CE1126" />
        </svg>
    `),p=t("antigua_and_barbuda_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66561)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 0.5L24 0.5L22.4348 12.5L1.56522 12.5L0 0.5Z"
                    fill="black" />
                <path
                    d="M12.0011 11.9813L5.79687 9.91328L8.95894 9.30734L6.27046 7.53708L9.42218 8.18852L7.6147 5.52486L10.2784 7.33234L9.62692 4.18062L11.3972 6.86909L12.0031 3.70703L12.6091 6.86909L14.3793 4.18062L13.7279 7.33234L16.3915 5.52486L14.5841 8.18852L17.7358 7.53708L15.0473 9.30734L18.2094 9.91328L12.0052 11.9813H12.0011Z"
                    fill="#FCD116" />
                <path
                    d="M1.56641 9.8916L22.436 9.8916V15.109L1.56641 15.109L1.56641 9.8916Z"
                    fill="#0072C6" />
                <path
                    d="M0 0.5L12 24.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="#CE1126" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66561">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as AntiguaAndBarbuda,p as AntiguaAndBarbudaRounded};
